import { SchedulePayload } from 'models';
import { tokenAuthApiInstance } from 'utils/auth';

import { ADD_SCHEDULE_APPOINTMENT } from '../constants';

export type createScheduleResponseType = {
  PatientID: string;
  AppointmentRequestID: string;
};

export const createScheduleAppointment = async (
  scheduleAppPayload: SchedulePayload
): Promise<createScheduleResponseType | undefined> => {
  const response = await tokenAuthApiInstance.authAxios().post(ADD_SCHEDULE_APPOINTMENT, scheduleAppPayload);
  const { PatientID } = scheduleAppPayload;
  return response.data ? { PatientID, AppointmentRequestID: response.data } : undefined;
};
